/**
 * Nicha — format prix « 590 EUR » (montant + code devise) sur tout le site
 * S'adapte à Shopify.currency.active (changement de devise Markets)
 * BUILD: 2026-06-18-price-format-v3
 */
(function () {
  'use strict';

  const BUILD = '2026-06-18-price-format-v3';
  const CRITICAL_STYLE_ID = 'nicha-price-format-critical';
  const CRITICAL_CSS =
    'body.template-product .product__info-wrapper .price .price-item--regular:not(:has([data-nicha-price-formatted])),' +
    'body.template-product .product__info-wrapper .price .price-item--sale:not(:has([data-nicha-price-formatted])),' +
    'body.template-product .product__info-container .price .price-item--regular:not(:has([data-nicha-price-formatted])),' +
    'body.template-product .product__info-container .price .price-item--sale:not(:has([data-nicha-price-formatted])),' +
    'body.nicha-product-page .product__info-wrapper .price .price-item--regular:not(:has([data-nicha-price-formatted])),' +
    'body.nicha-product-page .product__info-wrapper .price .price-item--sale:not(:has([data-nicha-price-formatted])),' +
    'body.nicha-product-page .product__info-container .price .price-item--regular:not(:has([data-nicha-price-formatted])),' +
    'body.nicha-product-page .product__info-container .price .price-item--sale:not(:has([data-nicha-price-formatted]))' +
    '{color:transparent!important;-webkit-text-fill-color:transparent!important}';

  if (!document.getElementById(CRITICAL_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = CRITICAL_STYLE_ID;
    style.textContent = CRITICAL_CSS;
    document.head.appendChild(style);
  }

  const ATTR = 'data-nicha-price-formatted';

  const PRODUCT_PRICE_SELECTORS = [
    '.product__info-wrapper .price .price-item--regular .etrans-money',
    '.product__info-wrapper .price .price-item--sale .etrans-money',
    '.product__info-wrapper .price .price-item--regular',
    '.product__info-wrapper .price .price-item--sale',
    '.product__info-container .price .price-item--regular .etrans-money',
    '.product__info-container .price .price-item--sale .etrans-money',
    '.product__info-container .price .price-item--regular',
    '.product__info-container .price .price-item--sale',
    '.product__info .price .price-item--regular .etrans-money',
    '.product__info .price .price-item--sale .etrans-money',
    '.product__info .price .price-item--last .etrans-money',
    '[id*="price-template"] .etrans-money',
  ];

  const PRICE_LEAF_SELECTORS = [
    ...PRODUCT_PRICE_SELECTORS,
    '.price .price-item--regular .etrans-money',
    '.price .price-item--sale .etrans-money',
    '.price .price-item--regular',
    '.price .price-item--sale',
    '.nicha-gallery-price',
    '.cart-item__price .price-item--regular .etrans-money',
    '.cart-item__price .price-item--sale .etrans-money',
    '.cart-item__price .price-item--regular',
    '.cart-item__price .price-item--sale',
    '.totals__subtotal-value',
    '.cart__subtotal .price-item--regular',
    '.product-recommendations .price .price-item--regular .etrans-money',
    '.product-recommendations .price .price-item--sale .etrans-money',
    '.product-recommendations .price .price-item--regular',
    '.product-recommendations .price .price-item--sale',
    'product-recommendations.product-recommendations .price .price-item--regular .etrans-money',
    'product-recommendations.product-recommendations .price .price-item--regular',
    '.gp-product-price .money',
  ];

  let lastCurrency = '';

  const isProductPage = () =>
    document.body?.classList.contains('template-product') ||
    document.body?.classList.contains('nicha-product-page') ||
    /\/products\//.test(window.location.pathname);

  const getCurrencyCode = () => {
    const active = window.Shopify?.currency?.active;
    if (active) return String(active).toUpperCase();
    const moneyFormat = window.theme?.moneyFormat || window.Shopify?.theme?.moneyFormat || '';
    if (moneyFormat.includes('USD') || moneyFormat.includes('$')) return 'USD';
    if (moneyFormat.includes('GBP') || moneyFormat.includes('£')) return 'GBP';
    return 'EUR';
  };

  const isAlreadyFormatted = (text, currencyCode) => {
    const t = String(text || '').trim();
    return new RegExp(`^\\d+(?:[.,]\\d{1,2})?\\s+${currencyCode}$`).test(t);
  };

  const parseAmount = (text) => {
    if (!text) return null;
    const raw = String(text).trim();
    if (!raw || raw.includes('{{')) return null;
    if (isAlreadyFormatted(raw, getCurrencyCode())) {
      return parseFloat(raw.split(/\s+/)[0].replace(',', '.'));
    }

    let numStr = raw.replace(/[^\d,.']/g, '');
    if (!numStr) return null;

    if (numStr.includes(',') && numStr.includes('.')) {
      if (numStr.lastIndexOf(',') > numStr.lastIndexOf('.')) {
        numStr = numStr.replace(/\./g, '').replace(',', '.');
      } else {
        numStr = numStr.replace(/,/g, '');
      }
    } else if (numStr.includes(',')) {
      const parts = numStr.split(',');
      numStr = parts.length === 2 && parts[1].length <= 2 ? parts.join('.') : parts.join('');
    }

    const value = parseFloat(numStr);
    return Number.isFinite(value) ? value : null;
  };

  const formatAmount = (amount, currencyCode) => {
    const rounded = Math.round(amount * 100) / 100;
    const whole = Math.abs(rounded - Math.round(rounded)) < 0.001;
    const display = whole ? String(Math.round(rounded)) : rounded.toFixed(2);
    return `${display} ${currencyCode}`;
  };

  const getPriceLeaf = (el) => {
    if (!el || el.closest('.visually-hidden')) return null;
    const nested = el.querySelector(':scope > .etrans-money, :scope > .money');
    if (nested && nested.textContent.trim() && !nested.textContent.includes('{{')) return nested;
    if (el.matches('.etrans-money, .money, .price-item, .nicha-gallery-price')) return el;
    return el.childElementCount === 0 ? el : null;
  };

  const formatLeaf = (leaf) => {
    const currency = getCurrencyCode();
    const text = (leaf.textContent || '').trim();
    if (!text || text.includes('{{')) return false;

    const amount = parseAmount(text);
    if (amount == null) return false;

    const formatted = formatAmount(amount, currency);
    if (text !== formatted) {
      leaf.textContent = formatted;
    }
    leaf.setAttribute(ATTR, currency);
    return true;
  };

  const scanSelectors = (selectors) => {
    const currency = getCurrencyCode();
    if (currency !== lastCurrency) {
      document.querySelectorAll(`[${ATTR}]`).forEach((el) => el.removeAttribute(ATTR));
      lastCurrency = currency;
    }

    const seen = new Set();
    let formattedCount = 0;
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        const leaf = getPriceLeaf(el);
        if (!leaf || seen.has(leaf)) return;
        seen.add(leaf);
        if (formatLeaf(leaf)) formattedCount += 1;
      });
    });
    return formattedCount;
  };

  const markProductPriceReady = () => {
    if (!isProductPage()) return;
    const hasFormattedMainPrice = document.querySelector(
      '.product__info-wrapper .price [data-nicha-price-formatted], .product__info-container .price [data-nicha-price-formatted]'
    );
    if (hasFormattedMainPrice) {
      document.body.classList.add('nicha-price-ready');
    }
  };

  const scanProductPrice = () => {
    const count = scanSelectors(PRODUCT_PRICE_SELECTORS);
    markProductPriceReady();
    return count;
  };

  const scan = () => {
    scanSelectors(PRICE_LEAF_SELECTORS);
    markProductPriceReady();
  };

  const isProductPriceMutation = (mutation) => {
    const nodes = [mutation.target];
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => nodes.push(node));
    }
    return nodes.some((node) => {
      if (!node || node.nodeType === Node.TEXT_NODE) {
        return mutation.target?.closest?.('.product__info-wrapper .price, .product__info-container .price');
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      return (
        node.matches?.(
          '.etrans-money, .money, .price-item, .price-item--regular, .price-item--sale, .price'
        ) || node.closest?.('.product__info-wrapper .price, .product__info-container .price')
      );
    });
  };

  const init = () => {
    lastCurrency = getCurrencyCode();
    if (isProductPage()) {
      scanProductPrice();
    }
    scan();
    [50, 200, 600, 1200, 2500].forEach((delay) => setTimeout(scan, delay));
  };

  if (document.body) {
    scanProductPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    scanProductPrice();
    scan();
  });
  document.addEventListener('variant:change', () => {
    scanProductPrice();
    setTimeout(scan, 40);
  });

  if (!window.__NICHA_PRICE_FORMAT_OBSERVER__) {
    window.__NICHA_PRICE_FORMAT_OBSERVER__ = true;
    let scheduled = null;

    const observer = new MutationObserver((mutations) => {
      let productPriceChanged = false;
      let otherChanged = false;

      for (const mutation of mutations) {
        if (isProductPriceMutation(mutation)) {
          productPriceChanged = true;
        } else {
          const target = mutation.target;
          if (
            target?.nodeType === Node.TEXT_NODE ||
            target?.matches?.('.etrans-money, .money, .price-item, .price-item--regular, .price-item--sale') ||
            target?.closest?.('.price, .cart-item__price, .product-recommendations')
          ) {
            otherChanged = true;
          }
        }
      }

      if (productPriceChanged) {
        scanProductPrice();
      }

      if (otherChanged) {
        if (scheduled) cancelAnimationFrame(scheduled);
        scheduled = requestAnimationFrame(() => {
          scheduled = null;
          scan();
        });
      }
    });

    const root = document.documentElement || document.body;
    if (root) {
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      scanProductPrice();
      scan();
    }
  });

  window.NichaPriceFormat = { build: BUILD, refresh: scan, refreshProductPrice: scanProductPrice, getCurrencyCode };
})();
